import { render, staticRenderFns } from "./addDiscount.vue?vue&type=template&id=0d2cfc6b&scoped=true&"
import script from "./addDiscount.vue?vue&type=script&lang=js&"
export * from "./addDiscount.vue?vue&type=script&lang=js&"
import style0 from "./addDiscount.vue?vue&type=style&index=0&id=0d2cfc6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2cfc6b",
  null
  
)

export default component.exports